// eslint-disable-next-line no-shadow
export enum CHAT_STATUS_ENUM {
  ONLINE = 1,
  OFFLINE = 2,
  OCUPADO = 3,
  AUSENTE = 4,
}
